/* eslint-disable @typescript-eslint/typedef */
import { ActionReference, GameObjectReference, GameState } from "@shared/types";
import { LitElement, TemplateResult, css, html, nothing } from "lit";
import { customElement } from "lit/decorators.js";
import { getState, performAction } from "../services/routeService";
import { AudioManager } from "./AudioManager";

@customElement("game-canvas")
export class GameCanvas extends LitElement {
    public static styles = css`
        .game {
            height: 100%;
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: auto auto 1fr auto;
            grid-column-gap: 0px;
            grid-row-gap: 0px;
        }

        .title {
            text-align: center;
            margin-top: 10px;
        }

        .setting-button, .map-button{
            top: 10px; /* Verander deze waarde om de verticale positie aan te passen */
            right: 10px; /* Verander deze waarde om de horizontale positie aan te passen */
            width: 30px; /* Verander deze waarde om de breedte aan te passen */
            height: 30px; /* Verander deze waarde om de hoogte aan te passen */
            background-color: transparent; /* Maak de achtergrond doorzichtig */
            border: none; /* Verwijder de rand */
            padding: 0; /* Verwijder de padding */
            cursor: pointer;
            z-index: 3;
        }

        .setting-button:active, .map-button:active {
            box-shadow: none;
            position: relative ;
            top: .2em;
            z-index: 3;
            }

            .setting-button img, .map-button img {
            width: 100%; /* Zorg ervoor dat de afbeelding de volledige grootte van de knop inneemt */
            height: 100%; /* Zorg ervoor dat de afbeelding de volledige grootte van de knop inneemt */
        }

        .imagePopup img{

           width: 50vw;
        } .popup, .imagePopup {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background-color: rgba(0, 0, 0, 0.5); /* donkergrijze achtergrond met wat transparantie */
            padding: 900px; /* meer padding toegevoegd voor een grotere popup */
            border-color: red;
            border-radius: 10px; /* afgeronde hoeken */
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4); /* zachtere schaduw */
            z-index: 2;
            max-width: 80%; /* maximale breedte van de popup */
        }

        .popup-content, .imagePopup-content {
            background-color: rgba(50, 50, 50, 0.8); /* donkergrijze achtergrond met wat transparantie */
            width: 240px;
            height: 150px;
            border-radius: 10px; /* Afgeronde hoeken */
            display: flex;
            flex-direction: column;
            justify-content: center; /* Plaats de inhoud verticaal in het midden */
            align-items: center; /* Plaats de inhoud horizontaal in het midden */
            padding: 20px; /* Voeg wat padding toe aan alle zijden */
        }

        .popup-content label, .imagePopup-content label {
            /* Stijlen voor de labels in de popup */
            color: gray;
            font-weight: bold;
            text-transform: uppercase;
            font-size: 16px;
            display: block;
            margin-bottom: 10px; /* Voeg wat ruimte toe onder elk label */
        }

        .popup-content input[type="range"], .imagePopup-content input[type="range"] {
            /* Stijlen voor de range-inputs in de popup */
            width: 100%; /* Neem de volledige breedte van de container in beslag */
            margin-bottom: 10px; /* Voeg wat ruimte toe onder elke input */
        }

        
        .popup-content button, .imagePopup-content button {
            /* Stijlen voor de knop in de popup */
            background-color: lightgray;
            border: 1px solid #000000;
            padding: 10px;
            text-transform: uppercase;
            cursor: pointer;
            user-select: none;
            font-weight: bold;
            text-shadow: -1px -1px black, 1px 1px white;
            color: gray;
            border-radius: 7px;
            box-shadow: 0 .2em gray;
        }

    .popup-content button:hover, .imagePopup-content button:hover {
        /* Stijlen voor de knop wanneer er overheen wordt gehoverd */
        background-color: #ffffff;
    }

        label[for="volume"] {
            color: gray; /* kleur van de tekst */
            font-weight: bold; /* vetgedrukte tekst */
            text-transform: uppercase; /* hoofdletters */
            font-size: 16px; /* grootte van de tekst */
            display: block; /* zorgt ervoor dat de label de volledige breedte inneemt */
        }

        .header {
            display: flex;
            flex-direction: column;
            align-items: center;
            flex-grow: 1;
            position: relative;
            margin-top: 10px;
        }
        .headerButton{
            width: 100%;
            display:flex;
            justify-content: space-between;
        }
        .header img {
            width: 50%;
            height: auto;
            image-rendering: pixelated;
        }

        .header img:nth-child(n + 2) {
            position: absolute;
        }

        .content {
         flex-grow: 1;
        overflow: auto;
        margin-top: 10px;
        padding: 0 10px;
        position: relative; /* Voeg deze regel toe */
        }

        .footer {
    border-radius: 10px 10px 0 0;
    background-color: #a6a6a6;
    border: 1px solid #ffffff;
    margin-top: 10px;
    display: flex;
}

.footer .buttons {
    display: flex;
    flex-direction: row;
    overflow: hidden; /* Verberg de scrollbar wanneer deze niet nodig is */
    padding: 10px;
    justify-content: space-evenly;
}

.footer .button {
    background-color: lightgray;
    border: 1px solid #000000;
    padding: 10px 10px 5px 10px;
    margin: 0 0 10px 10px;
    text-transform: uppercase;
    cursor: pointer;
    display: inline-block;
    user-select: none;
    font-weight: bold;
    text-shadow: -1px -1px black, 1px 1px white;
    color: gray;
    border-radius: 7px;
    box-shadow: 0 .2em gray;
}

.footer .button.active {
    background-color: #ffffff;
}

.footer .button:active {
    box-shadow: none;
    position: relative;
    top: .2em;
}

.footer a {
    border-bottom: 1px solid #ffffff;
}

.buttons div {
    padding-left: 1%;
    padding-right: 1%;
}

/* Definieer eventuele andere stijlen die je wilt toepassen op de typemachine-tekst */
.content p {
    margin: 0 0 10px 0;
}
.content p:last-of-type {
    margin: 0;
}
    `;

    private roomTitle?: string;
    private previousRoomTitle?: string;
    private roomImages?: string[];
    private contentText?: string[];
    private actionButtons?: ActionReference[];
    private gameObjectButtons?: GameObjectReference[];
    private inventoryObjects?: GameObjectReference[];
    // private inventory?: GameObject[];
    private defaultGameObjectButtons?: GameObjectReference[];

    private selectedActionButton?: ActionReference;
    private selectedGameObjectButtons: Set<GameObjectReference> = new Set<GameObjectReference>();
    private showPopup: boolean;
    private showImagePopup: boolean;
    private audioManager: AudioManager;

    private constructor() {
        super();
        this.previousRoomTitle = this.roomTitle;
        this.showPopup = false;
        this.showImagePopup = false;
        this.togglePopup = this.togglePopup.bind(this);
        this.hidePopup = this.hidePopup.bind(this);
        this.handleVolumeChange = this.handleVolumeChange.bind(this);
        this.handleBackgroundMusicVolumeChange = this.handleBackgroundMusicVolumeChange.bind(this);
        this.audioManager = new AudioManager();
    }


    public connectedCallback(): void {
        super.connectedCallback();
        void this.refreshState();
        this.toggleImagePopup();

    }

    private async refreshState(): Promise<void> {
        const state: GameState = await getState();

        this.updateState(state);
    }

    private updateState(state: GameState): void {

        console.log("Updating state with roomTitle:", state.roomTitle);
        //Reset the component
        this.previousRoomTitle = this.roomTitle;

        this.roomTitle = state.roomTitle;
        this.roomImages = state.roomImages;
        this.contentText = state.text;
        this.actionButtons = state.actions;
        this.defaultGameObjectButtons = state.objects;
        this.gameObjectButtons = this.defaultGameObjectButtons;
        this.inventoryObjects = state.inventory;

        console.log("Updated state with roomTitle:", this.roomTitle);
        console.log(this.inventoryObjects, this.selectedActionButton?.alias);
        // this.inventory = state.inventory;

        if (this.selectedActionButton?.alias !== "Use") {
            this.selectedActionButton = undefined;
            this.selectedGameObjectButtons.clear();
        }


        if (this.roomTitle !== this.previousRoomTitle) {
            this.setupBackgroundMusic();

        }

        this.requestUpdate();

    }

    private setupBackgroundMusic(): void {
        this.audioManager.stopAllAudio();

        // Set up background music based on roomTitle
        switch (this.roomTitle) {
            case "Unknown place":
                const background5Volume = Math.min(this.getBackgroundMusicVolume() * 1, 1);
                this.audioManager.createAudio("backgroundviewMusic", "/assets/img/rooms/Adventure.mp3");
                this.audioManager.playAudio("backgroundviewMusic", background5Volume, true);
                break;
            case "Castle":
                const nimueladyVolume = Math.min(this.getBackgroundMusicVolume() * 1, 1);
                this.audioManager.createAudio("backgroundviewMusic", "/assets/img/rooms/nimuelady.mp3");
                this.audioManager.playAudio("backgroundviewMusic", nimueladyVolume, true);
                break;
            case "CastleSecret":
                const background6Volume = Math.min(this.getBackgroundMusicVolume() * 1, 1);
                this.audioManager.createAudio("backgroundviewMusic", "/assets/img/rooms/Adventure.mp3");
                this.audioManager.playAudio("backgroundviewMusic", background6Volume, true);
                break;
            case "Cave":
                const caveVolume = Math.min(this.getBackgroundMusicVolume() * 1.5, 1);
                const background1Volume = Math.min(this.getBackgroundMusicVolume() * 1, 1);
                this.audioManager.createAudio("caveMusic", "/assets/img/rooms/drippingwater.mp3");
                this.audioManager.playAudio("caveMusic", caveVolume, true);
                const monsterVolume = Math.min(this.getBackgroundMusicVolume() * 2, 1);
                this.audioManager.createAudio("monsterMusic", "/assets/img/rooms/monster.mp3");
                this.audioManager.playAudio("monsterMusic", monsterVolume, true);
                this.audioManager.createAudio("backgroundviewMusic", "/assets/img/rooms/Adventure.mp3");
                this.audioManager.playAudio("backgroundviewMusic", background1Volume, true);
                break;
            case "Forest":
                const forestVolume = Math.min(this.getBackgroundMusicVolume() * 1.5, 1);
                const background2Volume = Math.min(this.getBackgroundMusicVolume() * 1, 1);
                this.audioManager.createAudio("forestMusic", "/assets/img/rooms/bird.mp3");
                this.audioManager.playAudio("forestMusic", forestVolume, true);
                this.audioManager.createAudio("backgroundviewMusic", "/assets/img/rooms/Adventure.mp3");
                this.audioManager.playAudio("backgroundviewMusic", background2Volume, true);
                break;
            case "Forest Clearing":
                const forest1Volume = Math.min(this.getBackgroundMusicVolume() * 1.5, 1);
                const background7Volume = Math.min(this.getBackgroundMusicVolume() * 1, 1);
                this.audioManager.createAudio("forestMusic", "/assets/img/rooms/bird.mp3");
                this.audioManager.playAudio("forestMusic", forest1Volume, true);
                this.audioManager.createAudio("backgroundviewMusic", "/assets/img/rooms/Adventure.mp3");
                this.audioManager.playAudio("backgroundviewMusic", background7Volume, true);
                break;
            case "the hungry grotto":
                const background8Volume = Math.min(this.getBackgroundMusicVolume() * 1, 1);
                this.audioManager.createAudio("backgroundviewMusic", "/assets/img/rooms/Adventure.mp3");
                this.audioManager.playAudio("backgroundviewMusic", background8Volume, true);
                break;
            case "Limewall":
                const LimewallVolume = Math.min(this.getBackgroundMusicVolume() * 1.5, 1);
                this.audioManager.createAudio("limewalltMusic", "/assets/img/rooms/abandoned.mp3");
                this.audioManager.playAudio("limewallMusic", LimewallVolume, true);
                break;
            case "Secret flashback":
                const Limewall1Volume = Math.min(this.getBackgroundMusicVolume() * 1.5, 1);
                this.audioManager.createAudio("limewalltMusic", "/assets/img/rooms/abandoned.mp3");
                this.audioManager.playAudio("limewallMusic", Limewall1Volume, true);
                break;
            case "oceanpoint":
                // Create sea music
                const seaVolume = Math.min(this.getBackgroundMusicVolume() * 1.5, 1);
                const backgroundVolume = Math.min(this.getBackgroundMusicVolume() * 1, 1);
                this.audioManager.createAudio("seaMusic", "/assets/img/rooms/sea.mp3");
                this.audioManager.playAudio("seaMusic", seaVolume, true);
                this.audioManager.createAudio("backgroundviewMusic", "/assets/img/rooms/Adventure.mp3");
                this.audioManager.playAudio("backgroundviewMusic", backgroundVolume, true);
                break;
            case "Southview":
                const southviewVolume = Math.min(this.getBackgroundMusicVolume() * 1, 1);
                this.audioManager.stopAudio("backgroundMusic");
                this.audioManager.createAudio("southviewMusic", "/assets/img/rooms/youWokeIt.mp3");
                this.audioManager.playAudio("southviewMusic", southviewVolume, true);

                break;
            case "Lost Memories: Quest of the Forgotten Knight":

                const lostVolume = Math.min(this.getBackgroundMusicVolume() * 0.3, 1);
                const background3Volume = Math.min(this.getBackgroundMusicVolume() * 1, 1);
                this.audioManager.createAudio("introMusic", "/assets/img/rooms/introsong.mp3");
                this.audioManager.playAudio("introMusic", lostVolume, false);
                this.audioManager.createAudio("backgroundviewMusic", "/assets/img/rooms/Adventure.mp3");
                this.audioManager.playAudio("backgroundviewMusic", background3Volume, true);
                break;
            case "spiritbarrow":
                const spiritbarrowVolume = Math.min(this.getBackgroundMusicVolume() * 0.3, 1);
                const southview1Volume = Math.min(this.getBackgroundMusicVolume() * 1, 1);
                this.audioManager.createAudio("southviewMusic", "/assets/img/rooms/youWokeIt.mp3");
                this.audioManager.playAudio("southviewMusic", southview1Volume, true);
                this.audioManager.createAudio("SpiritbarrowMusic", "/assets/img/rooms/ambiance.mp3");
                this.audioManager.playAudio("SpiritbarrowMusic", spiritbarrowVolume, true);
                break;

        }
    }

    private async handleClickAction(button: ActionReference): Promise<void> {
        if (button.needsObject) {
            // if (button.alias === "examine") {
            //     this.gameObjectButtons = this.defaultGameObjectButtons?.concat(this.inventoryObjects!);
            // } else {
            //     this.gameObjectButtons = this.defaultGameObjectButtons;
            // }
            this.selectedActionButton = button;
            this.selectedGameObjectButtons.clear();

            this.requestUpdate();
        } else {
            const state: any = await performAction(button.alias);

            if (state === undefined) {
                return;
            }

            this.updateState(state);
        }
    }

    private async handleClickObject(button: GameObjectReference): Promise<void> {
        if (!this.selectedActionButton) {
            return;
        }

        this.selectedGameObjectButtons.add(button);
        if (this.selectedActionButton?.alias === "Use" && this.selectedGameObjectButtons.size < 2) {
            return;
        }

        const state: GameState | undefined = await performAction(
            this.selectedActionButton.alias,
            [...this.selectedGameObjectButtons].map((e) => e.alias)
        );

        console.log(this.selectedGameObjectButtons);

        if (this.selectedGameObjectButtons.size >= 2) {
            this.selectedActionButton = undefined;
            this.selectedGameObjectButtons.clear();
        }

        this.requestUpdate();

        if (state === undefined) {
            return;
        }

        this.updateState(state);
    }

    protected render(): TemplateResult {
        return html`
            <div class="game">
                ${this.renderTitle()} 
                ${this.renderHeader()} 
                ${this.renderContent()} 
                ${this.renderFooter()}
            </div>
        `;
    }

    private renderTitle(): TemplateResult {
        if (this.roomTitle) {
            return html`
            <div id="popup" class="popup" ?hidden="${!this.showPopup}">
                <div class="popup-content">
                    <label for="volume">TypeWriter Volume:</label>
                    <input type="range" id="volume" name="volume" min="0" max="1" step="0.1" value="${this.getVolume()}" @input="${this.handleVolumeChange}">
                    <label for="backgroundVolume">Background Music Volume:</label>
                    <input type="range" id="backgroundVolume" name="backgroundVolume" min="0" max="1" step="0.1" value="${this.getBackgroundMusicVolume()}" @input="${this.handleBackgroundMusicVolumeChange}">
                    <button @click="${this.togglePopup}">Resume Game</button>
                </div>
            </div>
            <div id="imagePopup" class="imagePopup" ?hidden="${this.showImagePopup}">
            <div class="imagePopup-content">
                <!-- Afbeelding toegevoegd aan de popup-content -->
                <img src="/assets/img/rooms/map.png" alt="Afbeelding">
            </div>
        </div>
            <div class="title">${this.roomTitle}</div> 

<div class="headerButton">
<button class="setting-button" @click="${this.togglePopup}">                        
    <img src="/assets/img/rooms/setting.png" alt="Afbeelding">

</button><button class="map-button" @click="${this.toggleImagePopup}">                        
    <img src="/assets/img/rooms/mapicon.png" alt="Afbeelding">
</button>
</div>
`;
        }

        return html`${nothing}`;
    }


    private handleVolumeChange(event: InputEvent): void {
        const volume: number = parseFloat((event.target as HTMLInputElement).value);
        console.log("TypeWriter volume changed to:", volume);
        if (this.typingSound) {
            this.typingSound.volume = volume;
            localStorage.setItem("typingSoundVolume", volume.toString());
        }
    }



    private getVolume(): number {
        const savedVolume: string | null = localStorage.getItem("typingSoundVolume");
        return savedVolume ? parseFloat(savedVolume) : 0.5;
    }

    private getBackgroundMusicVolume(): number {
        const savedVolume: string | null = localStorage.getItem("backgroundMusicVolume");
        return savedVolume ? parseFloat(savedVolume) : 0.5;
    }
    public toggleImagePopup(): void {
        this.showImagePopup = !this.showImagePopup;
        this.requestUpdate();
    }
    
    public closeImagePopup(): void {
        this.showImagePopup = false;
        this.requestUpdate();
    }
    
    public togglePopup(): void {
        this.showPopup = !this.showPopup;
        this.requestUpdate();
    }

    private handleBackgroundMusicVolumeChange(event: InputEvent): void {
        const volume: number = parseFloat((event.target as HTMLInputElement).value);
        console.log("Background music volume changed to:", volume);

        // Update the volume of the currently playing background music
        this.audioManager.setVolume("backgroundviewMusic", volume);
        this.audioManager.setVolume("seaMusic", volume);
        this.audioManager.setVolume("caveMusic", volume);
        this.audioManager.setVolume("monsterMusic", volume);
        this.audioManager.setVolume("forestMusic", volume);
        this.audioManager.setVolume("limewalltMusic", volume);
        this.audioManager.setVolume("introMusic", volume);
        this.audioManager.setVolume("southviewMusic", volume);
        this.audioManager.setVolume("SpiritbarrowMusic", volume);

        localStorage.setItem("backgroundMusicVolume", volume.toString());
    }
    public hidePopup(event: Event): void {
        if (event.target === this.shadowRoot?.querySelector(".popup")) {
            this.showPopup = false;
            this.requestUpdate();
        }
    }

    private renderHeader(): TemplateResult {
        if (this.roomImages && this.roomImages.length > 0) {
            return html`
                <div class="header">
                    ${this.roomImages?.map((url) => html`<img src="/assets/img/rooms/${url}.png" />`)}
                </div>
            `;
        }

        return html`${nothing}`;
    }

    private typingSound: any;

    private renderContent(): TemplateResult {
        const speed: number = 20;
        console.log("renderContent");

        const text: string[] = this.contentText || [];

        const combinedText: string = text.join("<br>"); // Voeg <br>-tags toe tussen de paragrafen

        const typewriterTextElement: HTMLParagraphElement = document.createElement("p");

        if (this.typingSound instanceof Audio) {
            this.typingSound.pause();
            this.typingSound = null;
        }

        // Initialize the typing sound
        this.typingSound = new Audio("/assets/img/rooms/typewriter.mp3");
        this.typingSound.loop = true;
        this.typingSound.volume = this.getVolume(); // Stel het volume in op basis van de huidige waarde van de schuifregelaar

        // Play the typing sound as soon as the content is loaded
        this.typingSound.play();

        let i: number = 0;
        const interval: NodeJS.Timeout = setInterval(() => {
            if (i < combinedText.length) {
                if (combinedText.charAt(i) === "<") {
                    // Wanneer '<' wordt gevonden, voeg de hele tag toe in plaats van één teken
                    const endIndex: number = combinedText.indexOf(">", i) + 1;
                    typewriterTextElement.innerHTML += combinedText.substring(i, endIndex);
                    i = endIndex;
                } else {
                    typewriterTextElement.innerHTML += combinedText.charAt(i);
                    i++;
                }
            } else {
                // stoppen
                this.typingSound.pause();

                clearInterval(interval);
            }
        }, speed);

        // Returning the typewriterTextElement for later use
        return html`
            <div class="content">
                <p>${typewriterTextElement}</p>
            </div>
        `;
    }
    private renderFooter(): TemplateResult {
        return html`    
            <div class="footer">
                <div class="buttons">
                    <div>
                        <a>Actions:</a><br>
                        ${this.actionButtons?.map(
            (button) => html`<a
                                class="button ${this.selectedActionButton === button ? "active" : ""}"
                                @click=${(): void => void this.handleClickAction(button)}
                                >${button.label}</a
                            >`
        )}
                    </div>
                    <div>
                        ${this.selectedActionButton
                ? html`
                                <a>Room:</a><br>
                                ${this.gameObjectButtons?.map(
                    (button) => html`<a
                                        class="button ${this.selectedGameObjectButtons.has(button)
                            ? "active"
                            : ""}"
                                        @click=${(): void => void this.handleClickObject(button)}
                                        >${button.name}</a
                                    >`
                )}
                            `
                : nothing}
                    </div>
                    <div>
                        ${this.selectedActionButton?.alias === "examine" || this.selectedActionButton?.alias === "Use"
                ? html`
                                <a>Inventory:</a><br>
                                ${this.inventoryObjects?.map(
                    (button) => html`<a
                                        class="button ${this.selectedGameObjectButtons.has(button)
                            ? "active"
                            : ""}"
                                        @click=${(): void => void this.handleClickObject(button)}
                                        >${button.name}</a
                                    >`
                )}
                            `
                : nothing}
                    </div>
                </div>
            </div>
        `;
    }
}
